const state = {
  sector: [],
  methanol: [],
  costCurve: [],
  ethanolRbob: [],
  production: [],
  reinvestment: [],
  utilization: [],
  globalUtilization: [],
  pricing: [],
};
const getters = {
  sector: (state) => state.sector,
  methanol: (state) => state.methanol,
  costCurve: (state) => state.costCurve,
  ethanolRbob: (state) => state.ethanolRbob,
  production: (state) => state.production,
  reinvestment: (state) => state.reinvestment,
  utilization: (state) => state.utilization,
  globalUtilization: (state) => state.globalUtilization,
  pricing: (state) => state.pricing,
};
const actions = {};
const mutations = {
  SET_SECTOR(state, sector) {
    state.sector = sector;
  },
  SET_METHANOL(state, methanol) {
    let formattedData = [];
    if(typeof methanol.methanex_price != 'undefined'){
      for(let i=0;i<methanol.methanex_price.length;i++){
        formattedData.push({
          date: methanol.date[i],
          methanex_price: methanol.methanex_price[i],
          stock_price: methanol.stock_price[i],
          year: methanol.year[i],
        });
        
      }

      if (formattedData.length > 0)
      sessionStorage.setItem("methanolData", JSON.stringify(formattedData));

    }
    state.methanol = methanol;
  },
  SET_COSTCURVE(state, costCurve) {
    sessionStorage.setItem("costCurveData", JSON.stringify(costCurve));
    state.costCurve = costCurve;
  },
  SET_ETHANOLRCB(state, ethanolRbob) {
    sessionStorage.setItem("ethanolRbob", JSON.stringify(ethanolRbob));
    state.ethanolRbob = ethanolRbob;
  },
  SET_PRODUCTION(state, production) {
    sessionStorage.setItem("productionData", JSON.stringify(production));
    state.production = production;
  },
  SET_REINVESTMENT(state, reinvestment) {
    state.reinvestment = reinvestment;
  },
  SET_UTILIZATION(state, utilization) {
    let formattedData = utilization.map(function(d){
      return {
        UtRate: d.utrate,
        UtRate2: d.utrate2,
        UtRate3: d.utrate3,
        date:  d.date,
        label: d.label,
        prices_perc:d.prices_perc,
        year:d.year
      }
    });
    sessionStorage.setItem("utilizationData", JSON.stringify(formattedData));
    state.utilization = utilization;
  },
  SET_GLOBALUTILIZATION(state, globalUtilization) {
    let formattedData = globalUtilization.map(function (d) {
      return {
        UtRate: d.utrate,
        date: d.date,
        price: d.price,
        symbol: d.symbol
      };
    });
    sessionStorage.setItem("globalData", JSON.stringify(formattedData));
    state.globalUtilization = globalUtilization;
  },
  SET_PRICING(state, pricing) {
    let formattedData = pricing.map(function(d){
      return {
        Asia_Prices: d.asia_prices,
        EU_Prices: d.eu_prices,
        US_Prices: d.us_prices,
        date: d.date
      }
    });
    sessionStorage.setItem("pricingData", JSON.stringify(formattedData));
    state.pricing = pricing;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
